// extracted by mini-css-extract-plugin
export var table = "_tq-0";